export const STORAGE_CONSTANT = {
    ZIP_CODES: 'zipCodes',
    ORDER_DETAIL: 'orderDetail',
    SURVEYS: 'surveys',
    ORDERS: 'orders'
}
